// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cra_wrapper__2ajKq","tableWrapper":"cra_tableWrapper__3U8Kn","blk":"cra_blk__3NYIl"};